(function () {
  function initAVHeroBuy() {
    var button = document.querySelector('[data-av-hero-add]');

    if (!button) return;
    if (button.getAttribute('data-av-ready') === 'true') return;

    button.setAttribute('data-av-ready', 'true');

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var variantId = button.getAttribute('data-variant-id');

      if (!variantId) {
        console.warn('AV Hero Buy: missing variant id');
        return;
      }

      var originalText = button.textContent.trim();

      button.classList.add('is-loading');
      button.textContent = 'Adding...';

      addToCartAndOpenDrawer(variantId)
        .then(function () {
          button.textContent = 'Added';

          setTimeout(function () {
            button.textContent = originalText;
            button.classList.remove('is-loading');
          }, 1200);
        })
        .catch(function (error) {
          console.error('AV Hero Buy error:', error);

          button.textContent = 'View cart';

          setTimeout(function () {
            window.location.href = '/cart';
          }, 700);
        });
    });
  }

  function addToCartAndOpenDrawer(variantId) {
    var sectionsToBundle = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: {
          sections: sectionsToBundle
        }
      })
    );

    sectionsToBundle = uniqueArray(sectionsToBundle);

    var body = JSON.stringify({
      id: Number(variantId),
      quantity: 1,
      sections: sectionsToBundle,
      sections_url: window.location.pathname
    });

    var fetchConfig = getFetchConfig();

    return fetch(getCartAddUrl(), {
      method: 'POST',
      headers: fetchConfig.headers,
      body: body
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            throw new Error(text || 'Add to cart failed');
          });
        }

        return response.json();
      })
      .then(function (parsedState) {
        updateThemeCart(parsedState);
        openCartDrawer(parsedState);
      });
  }

  function updateThemeCart(parsedState) {
    if (
      window.theme &&
      theme.pubsub &&
      theme.pubsub.PUB_SUB_EVENTS &&
      theme.pubsub.PUB_SUB_EVENTS.cartUpdate &&
      typeof theme.pubsub.publish === 'function'
    ) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'av-hero-buy',
        cart: parsedState
      });

      return;
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: parsedState
        }
      })
    );
  }

  function openCartDrawer(parsedState) {
    var drawer = document.querySelector('#CartDrawer');

    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
      return;
    }

    if (drawer) {
      drawer.removeAttribute('hidden');
      drawer.classList.remove('pointer-events-none');
      drawer.classList.add('active');
      drawer.classList.add('is-open');
      drawer.classList.add('open');

      document.body.classList.add('overflow-hidden');
      return;
    }

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: {
          open: true
        }
      })
    );

    setTimeout(function () {
      var cartIcon =
        document.querySelector('[aria-controls="CartDrawer"]') ||
        document.querySelector('#cart-icon-bubble') ||
        document.querySelector('.header__icon--cart') ||
        document.querySelector('a[href="/cart"]');

      if (cartIcon) {
        cartIcon.click();
      } else {
        window.location.href = '/cart';
      }
    }, 100);
  }

  function getCartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cart_add_url) {
      return theme.routes.cart_add_url;
    }

    return '/cart/add.js';
  }

  function getFetchConfig() {
    if (window.theme && theme.utils && typeof theme.utils.fetchConfig === 'function') {
      return theme.utils.fetchConfig('json');
    }

    return {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    };
  }

  function uniqueArray(array) {
    var result = [];

    array.forEach(function (item) {
      if (item && result.indexOf(item) === -1) {
        result.push(item);
      }
    });

    return result;
  }

  document.addEventListener('DOMContentLoaded', initAVHeroBuy);
  document.addEventListener('shopify:section:load', initAVHeroBuy);
  initAVHeroBuy();
})();